module.exports = __webpack_public_path__ + "static/media/aluminBalcony.d3ee76eb.jpeg";